<template>
  <div id="app" v-if="isLoad">
    <!-- 登录页和价格页使用独立页面布局，不加载后台框架 -->
    <router-view v-if="$route.path === '/login' || $route.path === '/pricing'" />
    <!-- 对于其他页面，使用container布局 -->
    <container v-else>
      <slot>
        <router-view/>
      </slot>
    </container>
  </div>
</template>

<script>
import container from './components/container.vue';

export default {
  components: {
    container
  },
  data() {
    return {
      isLoad: true
    };
  }
};
</script>

<style scoped>
html, body {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  overflow: auto;
}

#app {
  width: 100%;
  min-height: 100%;
  position: relative;
}
</style>
